const isObject = (obj: any) => {
  return typeof(obj) === 'object' && obj !== null;
}

const deepClone = (source: any, hash = new WeakMap()) => {
  // 如果不是对象，则直接返回
  if (!isObject(source)) {
    return source;
  }
  // 如果hash表中存在，获取hash表中存储过的值
  if (hash.has(source)) {
    return hash.get(source);
  }

  // 过滤数组还是对象
  const target = Array.isArray(source) ? [...source] : {...source};
  hash.set(source, target);

  // reflect.ownKeys方法取出包含symbol类型的所有的key
  Reflect.ownKeys(target).forEach((key: any) => {
    if (isObject(source[key])) {
      target[key] = deepClone(source[key], hash);
    } else {
      target[key] = source[key]
    }
  })
  return target;
}

export default deepClone;